var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"1200"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"viewer-image",attrs:{"src":_vm.url,"alt":"image"}},on))]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('img',{staticClass:"dialog-image",attrs:{"src":_vm.url,"alt":"image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }